import { render } from "./SendMx.vue?vue&type=template&id=772de3cc&scoped=true"
import script from "./SendMx.vue?vue&type=script&lang=js"
export * from "./SendMx.vue?vue&type=script&lang=js"

import "./SendMx.vue?vue&type=style&index=0&id=772de3cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772de3cc"]])

export default __exports__